import root from 'window-or-global';
import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import Raven from 'raven-js';
import ScrollToTop from './routes/ScrollToTop';
import {setLocale} from '@epic-core/common';
import Entry from './Entry';
import {clientInterceptors} from '@epic-core/axios-client';
import {LocalizationContext, mergeLocalizationDataAltStore} from '@epic-mw/localization';
import {LocalizationContext as CoreLocalizationContext} from '@epic-core/localization';
import {bootstrapSharedValues, sharedStore} from './app.initializers';
import {SharedValueContext} from '@epic-core/hooks';
import pako from 'pako';
import axios from 'axios';
import {RoutingRules} from './routes/RoutingRules';
import './webVitalsReporter';

clientInterceptors();
axios.defaults.timeout = 16000;

if (process.env.NODE_ENV === 'production') {
    Raven.config('https://cee74562e5b449b2985c90b34389295c@sentry.io/1197574').install();
}

const init = () => {
    const reactDomEle = root.document.getElementById('epicGamesReactWrapper');
    const renderClient = function renderClient() {
        const i18nContext = mergeLocalizationDataAltStore(
            root.__epic_client_state.LocalizationStore
        );
        ReactDOM.hydrate(
            <BrowserRouter>
                <SharedValueContext.Provider value={sharedStore}>
                    <LocalizationContext.Provider value={i18nContext}>
                        <CoreLocalizationContext.Provider value={i18nContext}>
                            <RoutingRules>
                                <ScrollToTop>
                                    <Entry rootCmsPage={root.cmsPage} />
                                </ScrollToTop>
                            </RoutingRules>
                        </CoreLocalizationContext.Provider>
                    </LocalizationContext.Provider>
                </SharedValueContext.Provider>
            </BrowserRouter>,
            reactDomEle
        );
    };

    // only proceed if the react ele exists
    if (reactDomEle) {
        const rawPreload = root.__epic_client_state;
        let dataPreload;
        if (rawPreload && typeof rawPreload === 'string') {
            //decompress the model from a Uint8Array inside of a string
            const preload = pako.inflate(rawPreload.split(','), {to: 'string'});
            dataPreload = JSON.parse(preload);
            root.__epic_client_state = dataPreload;
            setLocale(root.__locale);
        }
        bootstrapSharedValues(dataPreload).then(() => {
            renderClient();
        });
    } else {
        setTimeout(() => {
            init();
        }, 10);
    }
};

init();
